import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import TenantRegisterPage from './pages/TenantRegisterPage';
import GalleryPage from './pages/GalleryPage';
import PhotographerUploadPage from './pages/PhotographerUploadPage';
import DemoPage from './pages/DemoPage';
import AdminDashboard from './pages/AdminDashboard';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import AuthCallback from './pages/AuthCallback';
import DashboardRedirect from './pages/DashboardRedirect';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from '@/components/ui/sonner';

function AppRouter() {
  const location = useLocation();

  // Handle Google OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/t/:slug" element={<TenantRegisterPage />} />
      <Route path="/t/:slug/gallery/:galleryId" element={<GalleryPage />} />
      <Route path="/gallery/:galleryId" element={<GalleryPage />} />
      <Route path="/u/:token" element={<PhotographerUploadPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/dashboard" element={<DashboardRedirect />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={['tenant_admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/super"
        element={
          <ProtectedRoute roles={['super_admin']}>
            <SuperAdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" theme="dark" />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
